import { useEffect } from 'react';

const CLARITY_PROJECT_ID = 't3zxty4zyx';

declare global {
  interface Window {
    clarity: any;
  }
}

export const useClarity = (cognitoId?: string) => {
  useEffect(() => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return;
    }

    if (!window.clarity) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
      `;
      document.head.appendChild(script);
    }

    const checkClarity = () => {
      if (window.clarity && cognitoId) {
        window.clarity('identify', cognitoId);
      } else if (window.clarity) {
        return;
      } else {
        setTimeout(checkClarity, 100);
      }
    };

    checkClarity();
  }, [cognitoId]);
};

export default useClarity;
